// extracted by mini-css-extract-plugin
module.exports = {"PreTaxMonthSalary":"index-module_PreTaxMonthSalary_bacL1"};